module.exports = __webpack_public_path__ + "static/img/top_img1.c027440.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/media/top_img1.png
// module id = k044
// module chunks = 1